import { Extension, Meta } from "./base";
import { CodeableConcept, Coding } from "./codeableConcept";
import { Reference } from "./reference";
import { TInteractivity } from "./interactivity";

export type MedicalEncounterStatus =
  | "planned"
  | "arrived"
  | "triaged"
  | "in-progress"
  | "on-leave"
  | "unknown"
  | "finished";

export interface MedicalEncounter {
  _id?: string;
  id?: string;
  extensions: Extension[];
  subject?: Reference;
  class?: CodeableConcept;
  period?: Period;
  actualPeriod?: Period;
  status?: string; // TODO: use MedicalEncounterStatus type defined above
  reasonCode?: CodeableConcept[];
  diagnosis?: {
    condition: Reference;
    use: CodeableConcept;
    rank: number;
  }[];
  medicalHistory?: CodeableConcept[];
  participant?: {
    actor: Reference;
    type?: CodeableConcept[];
    period?: Period;
  }[];
  meta: Meta;
  triageType?: Coding;
  templatingRef?: { id: string; v: number };
}

export type EncounterType = "simple" | "full" | "paper";

export type CardFormProps = {
  patientId?: string;
  patientReference?: Reference;
  showDate?: boolean;
  encounterId?: string;
  interactivity: TInteractivity;
  isHistoricalEncounter?: boolean;
  onPrint?: boolean;
};

export const EncounterMode = {
  SIMPLE: "Simple Note",
  FULL: "Detailed Note",
  PAPER: "Paper Upload",
};
